import { PublicWidgets } from '@wix/wix-vod-api-site-based/dist/src/public/services/widgets/widgets';
import { toError } from '../../parsers/to-error';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
import { keysToCamelCase } from '@wix/wix-vod-shared/common';
export class PublicWidgetsService {
    constructor(httpClient, baseUrl) {
        this.getWidgetSettings = (widgetId) => this.publicWidgets
            .getSettings(widgetId)
            .then((response) => keysToCamelCase(response.data))
            .catch(toError);
        this.getWidgetSettingsByInstanceId = (instanceId) => this.publicWidgets
            .getSettingsByInstanceId(instanceId)
            .then((response) => keysToCamelCase(response.data))
            .catch(toError);
        this.buildVideoCardsDeeplinkUrl = ({ channelId, videoId, fallbackUrl, instance, }) => this.publicWidgets.buildVideoCardsDeeplinkUrl({
            host: PRODUCTION_HOSTS.catalog,
            channelId,
            videoId,
            fallbackUrl,
            instance,
        });
        this.buildChannelCardsDeeplinkUrl = ({ channelId, fallbackUrl, instance, }) => this.publicWidgets.buildChannelCardsDeeplinkUrl({
            host: PRODUCTION_HOSTS.catalog,
            channelId,
            fallbackUrl,
            instance,
        });
        this.publicWidgets = new PublicWidgets(httpClient, baseUrl);
    }
}
//# sourceMappingURL=widgets.js.map